import { useState } from "react";
import MenuItem from "@mui/material/MenuItem";
import { observer } from "mobx-react";
import { Box, TextField } from "@mui/material";
import Task from "../model/Task";
import DialogConstantForForecastMethod from "../dialogs/DialogConstantForForecastMethod";

const ForecastMethodPicker = ({ task }) => {
  const [open, setOpen] = useState(false);
  const isTask = task instanceof Task;

  if (
    (!task.forecastMethod &&
      task.plannedProgress &&
      task.plannedProgress.size > 0)
  ) {
    task.forecastMethod = "Default";
  }

  const handleChange = (task, event) => {
    let value = event.target.value;
    if (value === "Constant") {
      task.forecastMethod = value;
      setOpen(true);
    } else {
      task.forecastMethod = value;
    }
  };

  const handleConstantForForecastMethodClose = () => {
    setOpen(false);
  };

  const handleFacConstant = (constant) => {
    task.constantForcastValue = constant;
    setOpen(false);
  };

  const currentValue =
    task.forecastMethod !== null ? task.forecastMethod : "Default";

  // BudgetedRate vs. BudgetRate?

  return (
    <>
      <DialogConstantForForecastMethod
        open={open}
        onCancel={handleConstantForForecastMethodClose}
        onDone={(constant) => handleFacConstant(constant)}
      />
      <Box component="form">
        <TextField
          select
          id="forecast-method-select"
          value={currentValue}
          onChange={(event) => handleChange(task, event)}
          label="Forecast"
          variant="standard"
        >
          {(isTask || task.parent !== 0) ?
          <MenuItem value="Default">Default</MenuItem>
          : null // it's not valid to choose 'Default' on the task root, it needs to define what default is!
          }
          <MenuItem value="BudgetedRate">Budget Rate</MenuItem>
          <MenuItem value="PastCostPerformance">Past Cost Performance</MenuItem>
          <MenuItem value="PastSchedulePerformace">
            Past Schedule Performance
          </MenuItem>
          <MenuItem value="ScheduleAndCostIndexed">
            Schedule and Cost Indexed
          </MenuItem>
          <MenuItem value="BudgetAtCompletion">Budget at Completion</MenuItem>
          <MenuItem value="Constant">Constant</MenuItem>
        </TextField>
      </Box>
    </>
  );
};

export default observer(ForecastMethodPicker);
